import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'ugc-title',
  shadow: false,
})
export class UgcTitle {
  @Prop() class: string = '';
  @Prop() text: string = '';
  @Prop() size: number = 14;
  @Prop() weight: number | string = 700;
  @Prop() width: string = '';
  @Prop() height: number | string = 0;
  @Prop() lineHeight: number = 0;
  @Prop() isLineEllipsis: boolean = false;

  render() {
    const height = this.height !== 0 ? this.height : this.size + 2;
    const lineHeight = this.lineHeight !== 0 ? this.lineHeight : this.size + 2;

    const style: any = {
      width: this.width === '' ? 'auto' : this.width,
      lineHeight: `${lineHeight}px`,
      fontSize: `${this.size}px`,
      fontWeight: `${this.weight}`,
    };

    if (typeof this.height !== 'string') {
      style.maxHeight = `${height}px`;
    }

    return (
      <div
        class={{ 'ugc-overflow-hidden': true, truncate: this.isLineEllipsis, [this.class]: true }}
        style={style}
        innerHTML={this.text}
      />
    );
  }
}
